import { render, staticRenderFns } from "./VideoCourseDetail.vue?vue&type=template&id=5f7f62bd&scoped=true"
import script from "./VideoCourseDetail.vue?vue&type=script&lang=js"
export * from "./VideoCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoCourseDetail.vue?vue&type=style&index=0&id=5f7f62bd&prod&lang=css"
import style1 from "./VideoCourseDetail.vue?vue&type=style&index=1&id=5f7f62bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f62bd",
  null
  
)

export default component.exports